import React from 'react';
import PropTypes from 'prop-types';
import { ForgeIcon, ForgeInlineMessage } from '@tylertech/forge-react';
import { messageManager } from '../../System/messageManager/messageManager.js';
import './ViewOnlyInlineMessage.scss';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';

const ViewOnlyInlineMessage = ({ headerTabButtons, style = {} }) => {
  const { nameConventions } = useNameConventions();

  return (
    <ForgeInlineMessage slot="body-header" theme="info" style={style} className={`view-only-inline-message ${headerTabButtons && headerTabButtons.length ? 'view-only-inline-message-with-tabs' : ''}`}>
      <ForgeIcon external externalType="all" slot="icon" name="info" />
      <p className="forge-typography--body2">{messageManager(nameConventions).VIEW_ONLY_MODE}</p>
    </ForgeInlineMessage>
  );
};

ViewOnlyInlineMessage.propTypes = {
  headerTabButtons: PropTypes.array,
  style: PropTypes.object
};

export default ViewOnlyInlineMessage;
